import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import api from '../../config/axiosConfig';
import { getBaseUrl } from "../../config/api";
import "./NuevaVenta.css";
import { CheckCircle, Search, User } from "lucide-react";
import ModalRepresentantes from "./ModalRepresentantes ";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import LocationDropdowns from "../../components/LocationDropdowns";
import Preloader from "../../components/Preloader";
import { SaleService } from "../../services/SaleService";
import UbicacionVenta from "./UbicacionVenta";
import { UsuarioService } from "../../services/UsuarioService";
import Searchable from "../../components/Searchable";
import { ProductService } from "../../services/ProductService";
import { MarcasService } from "../../services/MarcasService";
import { MarcaParametrosService } from "../../services/MarcaParametrosService";

function formatearFechaParaInput(fecha) {
  if (!fecha) return "";
  const date = new Date(fecha);
  if (Number.isNaN(date.getTime())) return "";
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
}

const ModificarVenta = ({
  token,
  user,
  initialData = {},
  readOnly = false,
  onSave,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const savedDatosAdicionalesRef = useRef([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [form, setForm] = useState({
    // Paso 1: Información del Cliente
    codigoCliente: initialData.codigoCliente || "",
    tipoDocumento: initialData.tipoDocumento || "",
    numeroDocumento: initialData.numeroDocumento || "",
    nombres: initialData.nombres || "",
    apellidoPaterno: initialData.apellidoPaterno || "",
    apellidoMaterno: initialData.apellidoMaterno || "",
    telefonoContacto: initialData.telefonoContacto || "",
    telefonoContacto2: initialData.telefonoContacto2 || "",
    nombresCompletos: initialData.nombresCompletos || "",
    vendedor_id: initialData.vendedor_id || "",

    // Paso 2: Datos de ubicación
    departamento: initialData.departamento || "",
    provincia: initialData.provincia || "",
    distrito: initialData.distrito || "",
    zone: initialData.zone || "",
    direccion: initialData.direccion || "",
    direccionReferencia: initialData.direccionReferencia || "",
    correoElectronico: initialData.correoElectronico || "",
    latitud: initialData.latitud || null,
    longitud: initialData.longitud || null,

    // Paso 3: Información del producto
    ventaDetalleId: initialData.ventaDetalleId || "",
    categoriaProducto: initialData.categoriaProducto || "",
    producto: initialData.producto || "",
    precio: initialData.precio || "",
    telefonoMigrar: initialData.telefonoMigrar || "",
    fechaInstalacion: initialData.fechaInstalacion || "",
    amPm: initialData.amPm || "",

  });

  const [productos, setProductos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [requisitos, setRequisitos] = useState([]);
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingCategorias, setLoadingCategorias] = useState(false);
  const [fechaFormateada, setFechaFormateada] = useState("");
  const [tiposDocumentos, setTiposDocumentos] = useState([]);
  const [representantes, setRepresentantes] = useState([]);
  const [vendedores, setVendedores] = useState([]);
  const [mostrarModalRepresentantes, setMostrarModalRepresentantes] =
    useState(false);

  // Estado para las ubicaciones
  const [locationData, setLocationData] = useState({
    department: initialData.department_id || "",
    province: initialData.province_id || "",
    district: initialData.district_id || "",
    zone: initialData.zone_id || "",
  });

  const [selectedMarcaId, setSelectedMarcaId] = useState(null);
  const [parametros, setParametros] = useState([]);
  const [hasParametros, setHasParametros] = useState(false);
  const [datosAdicionalesForm, setDatosAdicionalesForm] = useState({});
  const [marcas, setMarcas] = useState([]);
  const [loadingMarcas, setLoadingMarcas] = useState(false);

  const [loadingParametros, setLoadingParametros] = useState(false);



  // Función para validar que solo se ingresen números
  const validateNumericInput = (value) => {
    return value.replace(/\D/g, "");
  };

  // Función para manejar cambios en campos numéricos
  const handleNumericChange = (e) => {
    const { name, value } = e.target;
    const numericValue = validateNumericInput(value);
    setForm((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
    if (name === "numeroDocumento") {
      setRepresentantes([]);
    }
  };

  useEffect(() => {
    if (requisitos.length > 0) {
      const camposDocumentos = requisitos.reduce((acc, req) => {
        const campo = req.nombre_campo;
        acc[campo] = null;
        acc[`${campo}Preview`] = null;
        return acc;
      }, {});

      setForm((prev) => ({
        ...prev,
        ...camposDocumentos,
      }));
    }
  }, [requisitos]);

  const abrirModalRepresentantes = () => setMostrarModalRepresentantes(true);
  const cerrarModalRepresentantes = () => setMostrarModalRepresentantes(false);

  const actualizarRepresentantes = (nuevosRepresentantes) => {
    setRepresentantes(nuevosRepresentantes);
    cerrarModalRepresentantes();
  };

  const handleBackToList = () => {
    navigate("/admin/ventas");
  };

  useEffect(() => {
    if (form.tipoDocumento !== '4') {
      const nombresCompletos = `${form.nombres} ${form.apellidoPaterno} ${form.apellidoMaterno}`.trim();
      setForm(prev => ({ ...prev, nombresCompletos }));
    }
  }, [form.nombres, form.apellidoPaterno, form.apellidoMaterno, form.tipoDocumento]);

  const fetchMarcaById = async (marcaId, savedData) => {
    if (!marcaId) return;
    setLoadingMarcas(true);
    try {
      console.log(savedData)
      const camposDisponibles = await fetchParametros(marcaId);

      const valorMap = {};
      camposDisponibles.forEach((p) => {
        valorMap[p.nombre_campo] = "";
      });

      let datosReales = [];
      if (Array.isArray(savedData)) {
        datosReales = savedData;
      } else if (savedData && Array.isArray(savedData.data)) {
        datosReales = savedData.data;
      } else if (savedData && typeof savedData === 'object') {
        const posibleArray = Object.values(savedData).find(val => Array.isArray(val));
        if (posibleArray) datosReales = posibleArray;
      }

      if (datosReales.length > 0) {
        datosReales.forEach((dato) => {
          if (dato?.nombre_campo) {
            valorMap[dato.nombre_campo] = dato.valor || "";
          }
        });
      }

      setDatosAdicionalesForm(valorMap);

    } catch (err) {
      console.error("Error crítico al procesar la marca y sus campos:", err);
    } finally {
      setLoadingMarcas(false);
    }
  };

  const fetchMarcas = async (vendedorId) => {
    if (!vendedorId) return;
    setLoadingMarcas(true);
    try {
      const data = await MarcasService.getMarcasByUserId({ token, userId: vendedorId });
      setMarcas(data);
      setParametros([]);
      setHasParametros(false);
      setDatosAdicionalesForm({});
    } catch (err) {
      console.error("Error al cargar marcas:", err);
    } finally {
      setLoadingMarcas(false);
    }
  };

  const fetchParametros = async (marcaId) => {
    if (!marcaId) {
      setParametros([]);
      setHasParametros(false);
      return [];
    }
    setLoadingParametros(true);
    try {
      const data = await MarcaParametrosService.getByMarcaId({ token, marca_id: marcaId });
      setParametros(data);
      setHasParametros(data && data.length > 0);
      return data;
    } catch (err) {
      console.error("Error al cargar parámetros:", err);
      setHasParametros(false);
    } finally {
      setLoadingParametros(false);
    }
  };

  const handleDatosAdicionalesChange = (fieldName, value) => {
    setDatosAdicionalesForm((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const fetchVenta = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/ventas/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const ventaData = response.data.venta;
      const clienteData = response.data.cliente;
      const ventaDetallesData = response.data.ventaDetalles;
      const fotosRequisitos = response.data.fotosVenta;

      if (ventaData?.id_estado_servicio !== 1) {
        navigate('/admin/ventas');
        return;
      }

      if (ventaDetallesData.marca_id) {
        setSelectedMarcaId(Number(ventaDetallesData.marca_id));
        fetchProductos(ventaDetallesData.categoria_id, ventaDetallesData.marca_id);
      } else {
        fetchProductos(ventaDetallesData.categoria_id);
      }

      const datosResp = await api.get(`/ventas/datos-adicionales/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const savedDatosAdicionales = datosResp.data || [];
      savedDatosAdicionalesRef.current = savedDatosAdicionales;

      setForm({
        codigoCliente: ventaData.codigo_venta_cliente || "",
        tipoDocumento: String(clienteData.id_tipo_documentos || ""),
        numeroDocumento: clienteData.numero_documento || "",
        nombres: clienteData.nombres || "",
        apellidoPaterno: clienteData.ap_paterno || "",
        apellidoMaterno: clienteData.ap_materno || "",
        telefonoContacto: clienteData.telefono_1 || "",
        telefonoContacto2: clienteData.telefono_2 || "",
        nombresCompletos: clienteData.cliente_razon_social || "",
        vendedor_id: ventaData.id_usuario || "",
        nombre_vendedor: ventaData.nombre_vendedor,
        perfil_vendedor: ventaData.perfil_vendedor,
        apellido_vendedor: ventaData.apellido_vendedor,
        departamento: clienteData.department_id || "",
        provincia: clienteData.province_id || "",
        distrito: clienteData.district_id || "",
        zone: clienteData.id_region || "",
        direccion: clienteData.direccion || "",
        direccionReferencia: clienteData.direccion_referencia || "",
        correoElectronico: clienteData.email || "",
        categoriaProducto: ventaDetallesData.categoria_id || "",
        latitud: ventaData.latitud_cliente || null,
        longitud: ventaData.longitud_cliente || null,
        ventaDetalleId: ventaDetallesData.id || "",
        producto: ventaDetallesData.id_producto || "",
        precio: ventaDetallesData.precio || "",
        telefonoMigrar: ventaDetallesData.telefono_migrar || "",
        fechaInstalacion: ventaDetallesData.fecha_programacion ? formatearFechaParaInput(ventaDetallesData.fecha_programacion) : "",
        amPm: ventaDetallesData.AM_PM || "",
        dniFrontal: null,
        dniFrontalPreview: null,
        dniPosterior: null,
        dniPosteriorPreview: null,
        rostroClienteDni: null,
        rostroClienteDniPreview: null,
        frontisCasa: null,
        frontisCasaPreview: null,
        reciboLuz: null,
        reciboLuzPreview: null,
        otrosDocumentos: null,
        otrosDocumentosPreview: null,
      });

      setLocationData((prev) => ({
        ...prev,
        department: String(clienteData.department_id).padStart(2, '0'),
        province: String(clienteData.province_id).padStart(4, '0'),
        district: String(clienteData.district_id).padStart(6, '0'),
        zone: clienteData.id_region,
      }));

      if (ventaData.id_usuario) {
        fetchMarcas(ventaData.id_usuario);
      }

      if (ventaDetallesData.marca_id) {
        try {
          await fetchMarcaById(String(ventaDetallesData.marca_id), savedDatosAdicionales);
        } catch (err) {
          console.error("Error al cargar producto para obtener marca:", err);
        }
      }

      const baseUrl = getBaseUrl();

      const previews = {};

      if (Array.isArray(fotosRequisitos)) {
        fotosRequisitos.forEach((foto) => {
          if (!foto.nombre_campo || !foto.nombre_archivo) return;

          const previewField = `${foto.nombre_campo}Preview`;
          previews[previewField] = `${baseUrl}/uploads/${foto.nombre_archivo}`;
        });
      }

      setForm((prev) => ({
        ...prev,
        ...previews,
      }));


      const fechaActual = new Date(ventaData.fecha_venta);
      const opcionesFecha = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      setFechaFormateada(
        fechaActual.toLocaleDateString("es-ES", opcionesFecha)
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error.response?.status === 404 && error.response?.data?.error === 'Venta no encontrada') {
        navigate('/admin/ventas');
        return;
      }
      console.error("Error al obtener la venta:", error);
    }
  };

  useEffect(() => {
    if (id) {
      cargarTipoDocumentos();
      fetchVendedores();
      fetchVenta();
      fetchCategorias();
      fetchRequisitos();
      fetchProductos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, token]);

  const fetchVendedores = async () => {
    setLoading(true);
    try {
      const data = await UsuarioService.fetchVendedores(token);
      setVendedores(data);
    } catch (err) {
      console.error("Error al cargar categorías:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategorias = async () => {
    setLoadingCategorias(true);
    try {
      const response = await api.get("/ajustes/categorias", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCategorias(response.data.categorias || []);
    } catch (err) {
      console.error("Error al cargar categorías:", err);
    } finally {
      setLoadingCategorias(false);
    }
  };

  const fetchRequisitos = async () => {
    try {
      const response = await api.get("/ventas/requisitos", {
        headers: { Authorization: `Bearer ${token}` },
      });

      setRequisitos(response.data || []);
    } catch (err) {
      console.error("Error al cargar requisitos:", err);
    }
  };

  const cargarTipoDocumentos = async () => {
    try {
      const response = await api.get("/ajustes/tipodocumentos",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setTiposDocumentos(response.data.tiposDocumentos || []);
    } catch (error) {
      console.error("Error al cargar tipos de Documentos:", error);
    }
  };


  const fetchProductos = async (categoriaId, marcaId = null) => {
    if (!categoriaId) return;
    setLoading(true);
    try {
      const productos = await ProductService.fetchProductosPorCategoria(token, categoriaId, marcaId);
      setProductos(productos || []);
    } catch (err) {
      console.error("Error al cargar productos:", err);
      setError("Error al cargar los productos.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (name === "vendedor_id") {
      setForm(prev => ({ ...prev, vendedor_id: value, categoriaProducto: "", producto: "", marca_id: "" }));
      setDatosAdicionalesForm({});
      setSelectedMarcaId(null);
      setParametros([]);
      setHasParametros(false);
      fetchMarcas(value);
      return;
    }
    if (name === "categoriaProducto") {
      fetchProductos(value, selectedMarcaId);
      setForm((prev) => ({ ...prev, producto: "", precio: "" }));
    }

    if (name === "producto") {
      const productoSeleccionado = productos.find(p => p.id === value);

      if (productoSeleccionado) {
        setForm((prev) => ({
          ...prev,
          precio: productoSeleccionado.precio,
        }));
      }
    }

    if (name === "tipoDocumento") {
      setRepresentantes([]);
      setForm(prev => ({
        ...prev,
        nombres: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        nombresCompletos: "",
      }));
    }
  };

  const handleFileChange = (fieldName, file) => {
    const MAX_FILE_SIZE_MB = 2;
    const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/jpg", "image/webp", "application/pdf"];

    if (file) {
      const fileSizeMB = file.size / (1024 * 1024);
      const fileType = file.type;

      if (!ALLOWED_TYPES.includes(fileType)) {
        setErrors((prev) => ({
          ...prev,
          [fieldName]: "Solo se permiten imágenes o archivos PDF",
        }));
        return;
      }

      if (fileSizeMB > MAX_FILE_SIZE_MB) {
        setErrors((prev) => ({
          ...prev,
          [fieldName]: "El archivo no debe superar los 2 MB",
        }));
        return;
      }

      setErrors((prev) => ({
        ...prev,
        [fieldName]: null,
      }));

      const reader = new FileReader();
      reader.onload = (e) => {
        setForm({
          ...form,
          [fieldName]: file,
          [`${fieldName}Preview`]: e.target.result,
        });
      };
      reader.readAsDataURL(file);
    } else {
      setForm({
        ...form,
        [fieldName]: null,
        [`${fieldName}Preview`]: null,
      });
      setErrors((prev) => ({
        ...prev,
        [fieldName]: null,
      }));
    }
  };

  const nextStep = () => {
    if (currentStep < 7) {
      if (currentStep === 2 && !hasParametros) {
        setCurrentStep(3);
        setError("");
        return;
      }
      setCurrentStep(currentStep + 1);
      setError("");
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      if (currentStep === 3 && !hasParametros) {
        setCurrentStep(1);
        setError("");
        return;
      }
      setCurrentStep(currentStep - 1);
      setError("");
    }
  };


  const buscarCliente = async () => {
    try {
      if (!form.numeroDocumento || form.numeroDocumento.trim() === "") {
        setErrors((prev) => ({
          ...prev,
          numeroDocumento: "Ingrese un número válido",
        }));
        return;
      }
      if (form.tipoDocumento === "1") {
        const response = await api.get(`/services/dni/${form.numeroDocumento}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data) {
          const cliente = response.data;

          setForm((prev) => ({
            ...prev,
            nombres: `${cliente.nombres}`,
            apellidoMaterno: `${cliente.apellido_materno}`,
            apellidoPaterno: `${cliente.apellido_paterno}`,
            nombresCompletos: cliente.nombres + " " + cliente.apellido_paterno + " " + cliente.apellido_materno
          }));

          setErrors((prev) => ({
            ...prev,
            numeroDocumento: null,
          }));
        }
      }

      if (form.tipoDocumento === "4") {
        const response = await api.get(`/services/ruc/${form.numeroDocumento}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data) {
          const cliente = response.data;

          setForm((prev) => ({
            ...prev,
            nombresCompletos: cliente.nombre_o_razon_social || "",
            direccion: cliente.direccion || "",
            departamento: cliente.ubigeo?.[0] || "",
            provincia: cliente.ubigeo?.[1] || "",
            distrito: cliente.ubigeo?.[2] || "",
          }));

          setLocationData((prev) => ({
            ...prev,
            department: cliente.ubigeo?.[0] || "",
            province: cliente.ubigeo?.[1] || "",
            district: cliente.ubigeo?.[2] || "",
            zone: "",
          }));

          setErrors((prev) => ({
            ...prev,
            numeroDocumento: null,
          }));
        }
      }
    } catch (err) {
      const mensaje =
        err.response?.data?.error || "Error al consultar el servicio";
      setErrors((prev) => ({
        ...prev,
        numeroDocumento: mensaje,
      }));
    }
  };


  const handleSelectMarca = async (marca_id) => {
    const idLimpio = Number(marca_id);
    setSelectedMarcaId(idLimpio);
    setForm(prev => ({ ...prev, marca_id: idLimpio, categoriaProducto: "", producto: "", precio: "" }));
    setDatosAdicionalesForm({});
    setHasParametros(false);
    await fetchMarcaById(String(idLimpio), []);
  };



  const validarPaso3 = async () => {
    const e = {};
    if (!form.tipoDocumento) e.tipoDocumento = "Tipo de documento es obligatorio";
    if (!form.numeroDocumento) e.numeroDocumento = "Número de documento es obligatorio";
    if (form.codigoCliente?.trim()) {
      const resultado = await SaleService.validarCodigo(token, form.codigoCliente);
      if (resultado.existe && resultado.id !== id) e.codigoCliente = 'El código ya existe';
    }
    if (form.tipoDocumento !== '4') {
      if (!form.nombres) e.nombres = "Nombres son obligatorios";
      if (!form.apellidoPaterno) e.apellidoPaterno = "Apellido paterno es obligatorio";
    } else if (!form.nombresCompletos) {
      e.nombresCompletos = "Razón Social es obligatorios";
    }
    if (user?.permisos?.includes("update_vendores_venta") && !form.vendedor_id) {
      e.vendedor_id = "Debe seleccionar un vendedor";
    }
    if (!form.telefonoContacto) e.telefonoContacto = "Teléfono de contacto es obligatorio";
    return e;
  };

  const validarPaso1 = () => selectedMarcaId ? {} : { marca_id: "Debe seleccionar una marca" };

  const validarPaso2 = () => {
    const e = {};
    parametros.forEach((param) => {
      if (param.requerido === 1 && !datosAdicionalesForm[param.nombre_campo]) {
        e[param.nombre_campo] = `${param.nombre_campo.replaceAll('_', ' ')} es obligatorio`;
      }
    });
    return e;
  };

  const validarPaso4 = () => {
    const e = {};
    if (!locationData.department) e.department = "Departamento es obligatorio";
    if (!locationData.province) e.province = "Provincia es obligatoria";
    if (!locationData.district) e.district = "Distrito es obligatorio";
    if (!form.direccion) e.direccion = "Dirección es obligatoria";
    return e;
  };

  const validarPaso6 = () => {
    const e = {};
    if (!form.categoriaProducto) e.categoriaProducto = "Categoría es obligatoria";
    if (!form.producto) e.producto = "Producto es obligatorio";
    if (!form.precio) e.precio = "Precio es obligatorio";
    return e;
  };

  const validarPaso7 = () => {
    const e = {};
    requisitos.forEach((req) => {
      if (req.obligatorio === "1" && req.nombre_campo &&
          !form[req.nombre_campo] && !form[`${req.nombre_campo}Preview`]) {
        e[req.nombre_campo] = `${req.descripcion} es obligatorio.`;
      }
    });
    return e;
  };

  const validarPaso = (step) => {
    const validadores = { 1: validarPaso1, 2: validarPaso2, 4: validarPaso4, 6: validarPaso6, 7: validarPaso7 };
    const validador = validadores[step];
    return validador ? validador() : {};
  };

  const construirFormData = () => {
    const fd = new FormData();
    fd.append("producto", form.producto);
    fd.append("monto", Number.parseFloat(form.precio) || 0);
    fd.append("codigoCliente", form.codigoCliente);
    fd.append("tipoDocumento", form.tipoDocumento);
    fd.append("numeroDocumento", form.numeroDocumento);
    fd.append("nombres", form.nombres);
    fd.append("apellidoPaterno", form.apellidoPaterno);
    fd.append("apellidoMaterno", form.apellidoMaterno);
    fd.append("telefonoContacto", form.telefonoContacto);
    fd.append("telefonoContacto2", form.telefonoContacto2);
    fd.append("nombresCompletos", form.nombresCompletos);
    fd.append("representantes", JSON.stringify(representantes));
    fd.append("vendedor_id", form.vendedor_id);
    fd.append("departamento", locationData.department || form.departamento);
    fd.append("provincia", locationData.province || form.provincia);
    fd.append("distrito", locationData.district || form.distrito);
    fd.append("zone", locationData.zone || form.zone);
    fd.append("direccion", form.direccion);
    fd.append("direccionReferencia", form.direccionReferencia);
    fd.append("correoElectronico", form.correoElectronico);
    fd.append("latitud_cliente", String(form.latitud));
    fd.append("longitud_cliente", String(form.longitud));
    fd.append("ventaDetalleId", form.ventaDetalleId);
    fd.append("categoriaProducto", form.categoriaProducto);
    fd.append("precio", form.precio);
    fd.append("telefonoMigrar", form.telefonoMigrar);
    fd.append("fechaInstalacion", form.fechaInstalacion);
    fd.append("amPm", form.amPm);
    fd.append("id_marca", selectedMarcaId || "");
    fd.append("datosAdicionales", JSON.stringify(datosAdicionalesForm));
    requisitos.forEach((req) => {
      if (form[req.nombre_campo] instanceof File) {
        fd.append(req.nombre_campo, form[req.nombre_campo]);
      }
    });
    return fd;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    if (readOnly) return;

    const stepErrors = currentStep === 3 ? await validarPaso3() : validarPaso(currentStep);

    if (Object.keys(stepErrors).length > 0) {
      setErrors(stepErrors);
      return;
    }

    if (currentStep < 7) {
      nextStep();
      return;
    }

    setLoading(true);
    try {
      const formData = construirFormData();
      await api.put(`/ventas/${id}`, formData, {
        headers: { Authorization: `Bearer ${token}` },
        "Content-Type": "multipart/form-data",
      });

      toast.success("Venta actualizada correctamente");
      navigate('/admin/ventas');

      setCurrentStep(1);
      if (onSave) onSave();
    } catch (err) {
      console.error("Error al registrar venta:", err);
      setError(err.response?.data?.error || "Error al registrar la venta.");
    } finally {
      setLoading(false);
    }
  };

  const renderStep1 = () => (
    <div className="form-section">
      <h3 className="section-title">Seleccionar Marca</h3>
      <p>Obligatorio: Seleccione una marca para continuar.</p>
      {loadingMarcas ? (
        <div className="loading">Cargando marcas...</div>
      ) : (
        <div className="marcas-grid">
          {(marcas || []).map((marca, index) => {
            const isSelected = selectedMarcaId !== null &&
              selectedMarcaId !== undefined &&
              Number(selectedMarcaId) === Number(marca.id_marca);

            return (
              <button
                type="button"
                key={marca.id_marca ? `marca-${marca.id_marca}` : `marca-idx-${index}`}
                className={`marca-card ${isSelected ? 'selected' : ''}`}
                onClick={() => handleSelectMarca(marca.id_marca)}
              >
                {marca.imagen ? (
                  <img src={`${getBaseUrl()}/uploads/${marca.imagen}`} alt={marca.descripcion} />
                ) : (
                  <div className="marca-placeholder">
                    <span>{marca.descripcion?.charAt(0) || "?"} </span>
                  </div>
                )}
                <div className="marca-card-label">{marca.descripcion} </div>

                {isSelected && (
                  <div className="marca-card-check">
                    <CheckCircle size={24} color="#fff" />
                  </div>
                )}
              </button>
            );
          })}
        </div>
      )}
      {errors.marca_id && (
        <span className="error">{errors.marca_id}</span>
      )}
    </div>
  );

  const renderStep2 = () => {
    if (!selectedMarcaId) {
      return (
        <div className="form-section">
          <h3 className="section-title">Datos Adicionales</h3>
          <p className="info-text">Seleccione una marca para ver los campos adicionales</p>
        </div>
      );
    }

    if (loadingParametros) {
      return (
        <div className="form-section">
          <h3 className="section-title">Datos Adicionales</h3>
          <div className="loading">Cargando campos...</div>
        </div>
      );
    }

    if (parametros.length === 0) {
      return (
        <div className="form-section">
          <h3 className="section-title">Datos Adicionales</h3>
          <p className="info-text">No hay campos adicionales configurados para esta marca</p>
        </div>
      );
    }

    return (
      <div className="form-section">
        <h3 className="section-title">Datos Adicionales</h3>
        <div className="form-grid">
          {parametros.map((parametro) => {
            const fieldName = parametro.nombre_campo;
            const value = datosAdicionalesForm[fieldName] || "";
            const isRequired = parametro.requerido === 1;

            if (parametro.tipo_campo === "textarea") {
              return (
                <div key={parametro.id} className="form-group full-width">
                  <label htmlFor={fieldName}>
                    {fieldName.replaceAll('_', ' ')} {isRequired && "*"}
                  </label>
                  <textarea
                    id={fieldName}
                    value={value}
                    onChange={(e) => handleDatosAdicionalesChange(fieldName, e.target.value)}
                    disabled={readOnly}
                    placeholder={`Ingrese ${fieldName.replaceAll('_', ' ')}`}
                    rows={3}
                  />
                  {errors[fieldName] && <span className="error">{errors[fieldName]}</span>}
                </div>
              );
            }

            if (parametro.tipo_campo === "selector") {
              let options = [];
              try {
                if (parametro.valores_selector) {
                  options = JSON.parse(parametro.valores_selector);
                }
              } catch (e) {
                console.error(e);
                options = [];
              }
              return (
                <div key={parametro.id} className="form-group">
                  <label htmlFor={fieldName}>
                    {fieldName.replaceAll('_', ' ')} {isRequired && "*"}
                  </label>
                  <select
                    id={fieldName}
                    value={value}
                    onChange={(e) => handleDatosAdicionalesChange(fieldName, e.target.value)}
                    disabled={readOnly}
                    className="form-select"
                  >
                    <option value="">Seleccionar...</option>
                    {options.map((opt) => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                  {errors[fieldName] && <span className="error">{errors[fieldName]}</span>}
                </div>
              );
            }

            if (parametro.tipo_campo === "boolean") {
              return (
                <div key={parametro.id} className="form-group">
                  <label>
                    {fieldName.replaceAll('_', ' ')} {isRequired && "*"}
                  </label>
                  <select
                    value={value}
                    onChange={(e) => handleDatosAdicionalesChange(fieldName, e.target.value)}
                    disabled={readOnly}
                    className="form-select"
                  >
                    <option value="">Seleccionar...</option>
                    <option value="true">Sí</option>
                    <option value="false">No</option>
                  </select>
                  {errors[fieldName] && <span className="error">{errors[fieldName]}</span>}
                </div>
              );
            }

            if (parametro.tipo_campo === "fecha") {
              return (
                <div key={parametro.id} className="form-group">
                  <label htmlFor={fieldName}>
                    {fieldName.replaceAll('_', ' ')} {isRequired && "*"}
                  </label>
                  <input
                    id={fieldName}
                    type="date"
                    value={value}
                    onChange={(e) => handleDatosAdicionalesChange(fieldName, e.target.value)}
                    disabled={readOnly}
                  />
                  {errors[fieldName] && <span className="error">{errors[fieldName]}</span>}
                </div>
              );
            }

            if (parametro.tipo_campo === "number") {
              return (
                <div key={parametro.id} className="form-group">
                  <label htmlFor={fieldName}>
                    {fieldName.replaceAll('_', ' ')} {isRequired && "*"}
                  </label>
                  <input
                    id={fieldName}
                    type="number"
                    value={value}
                    onChange={(e) => handleDatosAdicionalesChange(fieldName, e.target.value)}
                    disabled={readOnly}
                    step="0.01"
                    placeholder="Ingrese valor numérico"
                  />
                  {errors[fieldName] && <span className="error">{errors[fieldName]}</span>}
                </div>
              );
            }

            return (
              <div key={parametro.id} className="form-group">
                <label htmlFor={fieldName}>
                  {fieldName.replaceAll('_', ' ')} {isRequired && "*"}
                </label>
                <input
                  id={fieldName}
                  type="text"
                  value={value}
                  onChange={(e) => handleDatosAdicionalesChange(fieldName, e.target.value)}
                  disabled={readOnly}
                  placeholder={`Ingrese ${fieldName.replaceAll('_', ' ')}`}
                />
                {errors[fieldName] && <span className="error">{errors[fieldName]}</span>}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderStep3 = () => (
    <div className="form-section">
      <h3 className="section-title">Datos del Cliente</h3>

      <div className="form-grid">
        <div className="">
          <label htmlFor="codigoCliente">Código de Cliente</label>
          <input
            type="text"
            name="codigoCliente"
            value={form.codigoCliente}
            onChange={(e) => {
              handleChange(e);
            }}
            disabled={readOnly}
            placeholder="Código del cliente"
          />
          {errors.codigoCliente && (
            <span className="error">{errors.codigoCliente}</span>
          )}
        </div>
        <div className="">
          <label htmlFor="tipoDocumento">Tipo de Documento *</label>
          <select
            name="tipoDocumento"
            value={form.tipoDocumento}
            onChange={handleChange}
            disabled={readOnly}
          >
            <option value="">Selecciona tipo de documento</option>
            {tiposDocumentos.map((tipo) => (
              <option key={tipo.id} value={tipo.id}>
                {tipo.description}
              </option>
            ))}
          </select>
          {errors.tipoDocumento && (
            <span className="error">{errors.tipoDocumento}</span>
          )}
        </div>
      </div>

      <div className="form-grid">
        <div className="">
          <label htmlFor="numeroDocumento">Número de Documento *</label>
          <div className="input-with-button">
            <input
              type="text"
              name="numeroDocumento"
              value={form.numeroDocumento}
              onChange={handleNumericChange}
              disabled={readOnly}
              placeholder="Solo números"
            />
            {(form.tipoDocumento === "1" || form.tipoDocumento === "4") && (
              <button
                type="button"
                className="search-btn"
                title="Buscar cliente"
                onClick={buscarCliente}
              >
                <Search size={20} color="#ffffff" />
              </button>
            )}
          </div>
          {errors.numeroDocumento && (
            <span className="error">{errors.numeroDocumento}</span>
          )}
        </div>
        <div className="">
          <label htmlFor="nombres">Nombres *</label>
          <input
            type="text"
            name="nombres"
            value={form.nombres}
            onChange={handleChange}
            disabled={readOnly}
            readOnly={form.tipoDocumento === '4'}
            placeholder="Nombres del cliente"
          />
          {errors.nombres && <span className="error">{errors.nombres}</span>}
        </div>
      </div>

      <div className="form-grid">
        <div className="">
          <label htmlFor="apellidoPaterno">Apellido Paterno *</label>
          <input
            type="text"
            name="apellidoPaterno"
            value={form.apellidoPaterno}
            onChange={handleChange}
            disabled={readOnly}
            readOnly={form.tipoDocumento === '4'}
            placeholder="Apellido paterno"
          />
          {errors.apellidoPaterno && (
            <span className="error">{errors.apellidoPaterno}</span>
          )}
        </div>
        <div className="">
          <label htmlFor="apellidoMaterno">Apellido Materno</label>
          <input
            type="text"
            name="apellidoMaterno"
            value={form.apellidoMaterno}
            onChange={handleChange}
            disabled={readOnly}
            readOnly={form.tipoDocumento === '4'}
            placeholder="Apellido materno"
          />
          {errors.apellidoMaterno && (
            <span className="error">{errors.apellidoMaterno}</span>
          )}
        </div>
      </div>

      <div className="form-grid">
        <div className="">
          <label htmlFor="telefonoContacto">Teléfono de Contacto *</label>
          <input
            type="tel"
            name="telefonoContacto"
            value={form.telefonoContacto}
            onChange={handleNumericChange}
            disabled={readOnly}
            placeholder="Solo números"
          />
          {errors.telefonoContacto && (
            <span className="error">{errors.telefonoContacto}</span>
          )}
        </div>
        <div className="">
          <label htmlFor="nombresCompletos">Nombres Completos / Razón Social</label>
          <div className="input-with-button">
            <input
              type="text"
              name="nombresCompletos"
              value={form.nombresCompletos}
              onChange={handleChange}
              disabled={readOnly}
              readOnly={form.tipoDocumento !== '4'}
              placeholder="Nombres completos - Razón social..."
            />
            {form.tipoDocumento === "4" && (
              <button
                type="button"
                className="contact-btn"
                title="Seleccionar contacto"
                onClick={abrirModalRepresentantes}
              >
                <User size={24} color="white" />
              </button>
            )}
          </div>
          {mostrarModalRepresentantes && (
            <ModalRepresentantes
              clientesSeleccionados={representantes}
              onGuardar={actualizarRepresentantes}
              onCerrar={cerrarModalRepresentantes}
              numero={form.numeroDocumento}
              tipoDocumento={form.tipoDocumento}
              token={token}
            />
          )}
          {errors.nombresCompletos && (
            <span className="error">{errors.nombresCompletos}</span>
          )}
        </div>
      </div>
    </div>
  );

  const renderStep4 = () => {
    return (
      <div className="form-section">
        <h3 className="section-title"> Dirección del cliente</h3>

        <LocationDropdowns
          selectedDepartment={locationData.department}
          selectedProvince={locationData.province}
          selectedDistrict={locationData.district}
          selectedZone={locationData.zone}
          errors={errors}
          onDepartmentChange={(value) => {
            setLocationData((prev) => ({
              ...prev,
              department: value,
              province: "",
              district: "",
              zone: "",
            }));
            // Sincronizar con form
            setForm((prev) => ({
              ...prev,
              departamento: value,
              provincia: "",
              distrito: "",
              zone: "",
            }));
          }}
          onProvinceChange={(value) => {
            setLocationData((prev) => ({
              ...prev,
              province: value,
              district: "",
              zone: "",
            }));
            // Sincronizar con form
            setForm((prev) => ({
              ...prev,
              provincia: value,
              distrito: "",
              zone: "",
            }));
          }}
          onDistrictChange={(value) => {
            setLocationData((prev) => ({
              ...prev,
              district: value,
              zone: "",
            }));
            // Sincronizar con form
            setForm((prev) => ({
              ...prev,
              distrito: value,
              zone: "",
            }));
          }}
          onZoneChange={(value) => {
            setLocationData((prev) => ({
              ...prev,
              zone: value,
            }));
            // Sincronizar con form
            setForm((prev) => ({
              ...prev,
              zone: value,
            }));
          }}
          showZones={true}
          className="location-dropdowns"
          token={token}
        />

        <div className="form-grid">
          <div className="form-group">
            <label htmlFor="correoElectronico">Correo Electrónico</label>
            <input
              type="email"
              name="correoElectronico"
              value={form.correoElectronico}
              onChange={handleChange}
              disabled={readOnly}
              placeholder="Correo electrónico"
            />
            {errors.correoElectronico && (
              <span className="error">{errors.correoElectronico}</span>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="telefonoContacto2">Teléfono de Contacto (Opcional)</label>
            <input
              type="tel"
              name="telefonoContacto2"
              value={form.telefonoContacto2}
              onChange={handleNumericChange}
              disabled={readOnly}
              placeholder="Solo números (opcional)"
            />
            {errors.telefonoContacto2 && (
              <span className="error">{errors.telefonoContacto2}</span>
            )}
          </div>
        </div>

        <div className="form-grid">
          <div className="form-group">
            <label htmlFor="direccion">Dirección *</label>
            <textarea
              name="direccion"
              value={form.direccion}
              onChange={handleChange}
              disabled={readOnly}
              placeholder="Dirección"
              rows={3} // Puedes ajustar la altura inicial
              style={{ resize: "vertical" }} // Permite redimensionar verticalmente
            />
            {errors.direccion && (
              <span className="error">{errors.direccion}</span>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="direccionReferencia">Dirección de Referencia</label>
            <textarea
              name="direccionReferencia"
              value={form.direccionReferencia}
              onChange={handleChange}
              disabled={readOnly}
              placeholder="Dirección de referencia"
              rows={3}
              style={{ resize: "vertical" }}
            />
            {errors.direccionReferencia && (
              <span className="error">{errors.direccionReferencia}</span>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderStep5 = () => {
    return (
      <div className="form-section">
        <h3 className="section-title">Ubicación en el mapa</h3>
        <p>Verifica la ubicación aproximada del cliente en el mapa:</p>
        <UbicacionVenta form={form} setForm={setForm} />
      </div>
    );
  };

  const renderStep6 = () => (
    <div className="form-section">
      <h3 className="section-title">Datos del Producto</h3>

      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="categoriaProducto">Categoría Producto *</label>
          <select
            name="categoriaProducto"
            value={form.categoriaProducto}
            onChange={handleChange}
            disabled={readOnly || loadingCategorias}
            className="form-select"
          >
            <option value="">Seleccionar categoría</option>
            {categorias.map((categoria) => (
              <option key={categoria.id} value={categoria.id}>
                {categoria.nombre}
              </option>
            ))}
          </select>
          {errors.categoriaProducto && (
            <span className="error">{errors.categoriaProducto}</span>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="producto">Producto *</label>
          <select
            name="producto"
            value={form.producto}
            onChange={handleChange}
            disabled={readOnly || !form.categoriaProducto}
            className="form-select"
          >
            <option value="">Seleccionar producto</option>
            {productos.map((producto) => (
              <option key={producto.id} value={producto.id}>
                {producto.nombre} - S/ {producto.precio}
              </option>
            ))}
          </select>
          {errors.producto && <span className="error">{errors.producto}</span>}
        </div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="precio">Precio *</label>
          <input
            type="number"
            name="precio"
            value={form.precio}
            onChange={handleChange}
            disabled={readOnly}
            step="0.01"
            placeholder="Precio"
          />
          {errors.precio && <span className="error">{errors.precio}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="telefonoMigrar">Teléfono a Migrar</label>
          <input
            type="tel"
            name="telefonoMigrar"
            value={form.telefonoMigrar}
            onChange={handleNumericChange}
            disabled={readOnly}
            placeholder="Solo números"
          />
          {errors.telefonoMigrar && (
            <span className="error">{errors.telefonoMigrar}</span>
          )}
        </div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="fechaInstalacion">Fecha de Instalación</label>
          <input
            type="datetime-local"
            name="fechaInstalacion"
            value={form.fechaInstalacion}
            onChange={handleChange}
          />
          {errors.fechaInstalacion && (
            <span className="error">{errors.fechaInstalacion}</span>
          )}
        </div>
        {/*  <div className="form-group">
          <label>AM/PM</label>
          <select
            name="amPm"
            value={form.amPm}
            onChange={handleChange}
            disabled={readOnly}
          >
            <option value="">Seleccionar</option>
            {opcionesAmPm.map((opcion) => (
              <option key={opcion.value} value={opcion.value}>
                {opcion.label}
              </option>
            ))}
          </select>
          {errors.amPm && <span className="error">{errors.amPm}</span>}
        </div> */}
      </div>
    </div>
  );

  const renderStep7 = () => (
    <div className="form-section">
      <h3 className="section-title"> Documentos Requeridos</h3>

      <div className="document-grid">
        {requisitos.map((req) => {
          const fieldName = req.nombre_campo;
          const previewField = `${fieldName}Preview`;
          const isPdf =
            fieldName === "reciboLuz" || fieldName === "otrosDocumentos";
          const isRequired = req.obligatorio === "1";

          return (
            <div key={req.id} className="document-card">
              {form[previewField] ? (
                <div className="image-preview">
                  <img src={form[previewField]} alt={req.descripcion} />
                  <button
                    type="button"
                    className="remove-image"
                    onClick={() => handleFileChange(fieldName, null)}
                  >
                    ✕
                  </button>
                </div>
              ) : (
                <div className="document-icon">{isPdf ? "📄" : "📷"}</div>
              )}
              <label>
                {req.descripcion} {isRequired && "*"}
              </label>
              <input
                type="file"
                accept={isPdf ? "image/*,.pdf" : "image/*"}
                onChange={(e) => handleFileChange(fieldName, e.target.files[0])}
                disabled={readOnly}
              />
              {errors[fieldName] && (
                <span className="error">{errors[fieldName]}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );

  const renderCurrentStep = () => {
    const step = (currentStep === 2 && !hasParametros) ? 3 : currentStep;
    switch (step) {
      case 1:
        return renderStep1();
      case 2:
        return renderStep2();
      case 3:
        return renderStep3();
      case 4:
        return renderStep4();
      case 5:
        return renderStep5();
      case 6:
        return renderStep6();
      case 7:
        return renderStep7();
      default:
        return renderStep1();
    }
  };

  return (
    <div className="ventas-admin-content">
      {loading && <Preloader />}
      <div className="breadcrumb-container">
        <button type="button" className="breadcrumb-link" onClick={handleBackToList} style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "var(--color-primary)", textDecoration: "underline", font: "inherit" }}>
          ← Listado de Ventas
        </button>
        <span className="breadcrumb-current"> / Actualizar Venta</span>
      </div>
      <div className="dashboard-card nuevo-producto-card">
        <span className="nueva-venta-title"> Actualizar Venta</span>
        {user?.permisos?.includes("update_vendores_venta") ? (
          <span className="nueva-venta-subtitle">
            <div className="selector-vendedor">
              <label htmlFor="vendedor">Seleccionar vendedor:</label>

              <Searchable
                options={vendedores}
                value={form.vendedor_id}
                onChange={(id) => {
                  handleChange({
                    target: {
                      name: "vendedor_id",
                      value: id
                    }
                  });
                }}
                placeholder="Seleccione vendedor..."
                getOptionLabel={(v) => `${v.nombre} ${v.apellidoPaterno}`}
                getOptionValue={(v) => v.id}
              />
              {errors.vendedor_id && (
                <span className="error">{errors.vendedor_id}</span>
              )}
            </div>
          </span>
        ) : (
          <span className="nueva-venta-subtitle">
            {form.perfil_vendedor} - {form.nombre_vendedor + " " + form.apellido_vendedor}
          </span>
        )}

        <span className="nueva-venta-subtitle">
          {fechaFormateada}
        </span>

        <form
          className="nueva-venta-form"
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          {renderCurrentStep()}

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          {!readOnly && (
            <div className="form-actions">
              {currentStep > 1 && (
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={prevStep}
                  disabled={loading}
                >
                  Anterior
                </button>
              )}

              <button
                className="btn btn-primary"
                type="submit"
                disabled={loading}
              >
                {(() => {
                  if (loading) return "Procesando...";
                  if (currentStep === 7) return "Actualizar Venta";
                  return "Siguiente";
                })()}
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

ModificarVenta.propTypes = {
  token: PropTypes.string,
  user: PropTypes.object,
  initialData: PropTypes.object,
  readOnly: PropTypes.bool,
  onSave: PropTypes.func,
};

export default ModificarVenta;
